import { UiTypography } from '@/components/ui/Typography';

import {
  OptionIconStyles,
  OptionListStyles,
  OptionStyles,
} from './Option.styles';

export const OptionList: React.FC<{
  children: NonNullable<React.ReactNode>;
}> = ({ children }) => {
  return (
    <OptionListStyles className="options-list">{children}</OptionListStyles>
  );
};

export const Option: React.FC<{
  title: string;
  isSelected: boolean;
  onClick: () => void;
  Icon: React.FC;
  iconPosition: 'left' | 'right';
}> = ({ title, isSelected, onClick, Icon, iconPosition }) => {
  return (
    <OptionStyles
      onClick={onClick}
      isSelected={isSelected}
      className="option"
      role="button"
    >
      <OptionIconStyles position={iconPosition} isSelected={isSelected}>
        <Icon />
      </OptionIconStyles>

      <UiTypography variant="body-large">{title}</UiTypography>
    </OptionStyles>
  );
};
